import { render } from "./Rubric.vue?vue&type=template&id=69ff08ff&ts=true&lang=html"
import script from "./Rubric.vue?vue&type=script&lang=ts"
export * from "./Rubric.vue?vue&type=script&lang=ts"

import "./Rubric.vue?vue&type=style&index=0&id=69ff08ff&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__